import { postWithAuth, getWithAuth } from '../../../Basic/HttpService';

export let getVORLoggedBy = async (id) => {
    let data = await getWithAuth(`VORLoggedBy/VORLoggedBy_GetDetails/${id}`);
    return data;
};

export const postVORLoggedBy = async (data) => {
    let res = await postWithAuth(`VORLoggedBy/VORLoggedBy_AddUpdate`, data);
    return res;
};
